import React, { useContext, useMemo, useState } from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import GroupReportContext from '../../../../Context/GroupReportContext';
import { initialData } from '../groupReport-pdf/QuadrantInFocus';
import { useGroupReportDate } from '../../../../Context/GroupReportDate';

const HeartPreview360 = ({ apiData, reportType, pageNumber }) => {


  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';
  const groupReportCtx = useContext(GroupReportContext);
  const {tablevaluesq2: tablevaluesq2Raw} = useGroupReportDate();

  // Merge all page data into a single array
  const tablevaluesq2 = useMemo(() => {
    if (!tablevaluesq2Raw) return [];

    const mergedData = [];
    // Merge data from all pages (page1, page2, page3, page4)
    ['page1', 'page2', 'page3', 'page4'].forEach(pageKey => {
      if (tablevaluesq2Raw[pageKey] && Array.isArray(tablevaluesq2Raw[pageKey])) {
        mergedData.push(...tablevaluesq2Raw[pageKey]);
      }
    });

    return mergedData;
  }, [tablevaluesq2Raw]);

  const [dynamicData, setDynamicData] = useState([...initialData]);

  const questions = [
    {
      id: 1,
      question: 'When presented with a problem, [First Name] is most concerned with how the team is handling it.',
      quadrant: 'HEART',
    },
    {
      id: 2,
      question: '[First Name] ensures their decisions are measured by whether everyone is on board.',
      quadrant: 'HEART',
    },
    {
      id: 3,
      question: '[First Name] feels most fulfilled when surrounded by their people.',
      quadrant: 'HEART',
    },
    {
      id: 4,
      question: '[First Name] is motivated when they feel a sense of belonging.',
      quadrant: 'HEART',
    },
    {
      id: 5,
      question: '[First Name] relies heavily on passion when working on a project.',
      quadrant: 'HEART',
    },
    {
      id: 6,
      question: '[First Name] believes a collaborative team is the best way to achieve results.',
      quadrant: 'HEART',
    },
    {
      id: 7,
      question: '[First Name] wants to feel connected to others while doing something.',
      quadrant: 'HEART',
    },
    {
      id: 8,
      question: 'When working on a project, [First Name] can become too emotionally invested.',
      quadrant: 'HEART',
    },
    {
      id: 9,
      question: "[First Name]'s strong feelings sometimes overwhelm good judgment.",
      quadrant: 'HEART',
    },
    {
      id: 10,
      question: '[First Name] finds satisfaction in feeling connected to the people they work with.',
      quadrant: 'HEART',
    },
  ];

  const styles = {
    container: { paddingTop: '16px' },
    heading: { fontSize: "14px", paddingBottom: "16px", lineHeight: "18px", fontWeight: 700, color: "#426B88", margin: 0, fontFamily: "'Helvetica', sans-serif", letterSpacing: 0 },
    description: { marginBottom: "16px", color: "#245775", marginTop: 0, fontFamily: "'Helvetica', sans-serif", fontWeight: 400, fontStyle: 'normal', fontSize: '12px', lineHeight: '18px', letterSpacing: '0px' },
    tableWrapper: { overflow: "hidden", border: "0.25px solid #0000001A", borderRadius: "16px" },
    table: { width: "100%", borderCollapse: "separate", borderSpacing: "0", lineHeight: "13px", },
    th: { padding: "0 12px", backgroundColor: "#245775", color: "white", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, lineHeight: "13px", fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px' },
    td: { borderLeft: "0.67px solid #ddd", padding: "5px", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px', color: "#000000" },     heartColumn: { width: "100%", textAlign: "left", padding: "5.5px 15px", border: "none", fontSize: "9px", fontWeight: 400 },
    rowEven: { backgroundColor: "#FFF" },
    rowOdd: { backgroundColor: "#F1F3F3" },
    rectangleWrapper: { display: "flex", justifyContent: "center", alignItems: "center", height: "26px", width: "25px", margin: "0 auto" },
    rectangle: { width: "16px", height: "16px", backgroundColor: "#B6111F", borderRadius: "1.34px" }
  };

  const renderRectangle = (avgScore, index) => {
    const full = Math.floor(avgScore);
    const partial = avgScore - full;
    if (index < full) {
      // Full blue square
      return <div style={styles.rectangle}></div>;
    } else if (index === full && partial > 0) {
      // Partial blue square (only blue part, no light background)
      return (
        <div style={{ ...styles.rectangle, position: 'relative', overflow: 'hidden', backgroundColor: 'transparent' }}>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: `${partial * 100}%`,
            height: '100%',
            backgroundColor: '#B6111F',
            borderRadius: '2px',
            zIndex: 2,
          }}></div>
        </div>
      );
    } else {
      return null;
    }
  };

  const displayData = dynamicData;
  const allMembersDataArray = Object.values(apiData?.memberResults?.allMembersData || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);

  const quadrantScores = {
    "HEART": 1,
    "SOUL": 2,
    "MIND": 3,
    "STRENGTH": 4
  }
  const allResults = [];
  displayData?.forEach((el, index) => {
    // Only process HEART quadrant items (quadrant score 1)
    if (quadrantScores?.[el.quadrant] === 1 && tablevaluesq2[index]) {
      // Get the last value from the array (index 5) which is the average score
      const averageScore = tablevaluesq2[index]?.[5];
      allResults.push({
        averageScore: averageScore,
        quadrant: el.quadrant,
        no: el.no,
        ques: el?.question
      });
    }
  });

  // console.log("allResults", allResults)


  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div className="three60-focus-container">
        <h1 className="three60-focus-heading">HEART 360 IN FOCUS</h1>
        <p className="three60-focus-description">
          This chart isolates the items related to the Heart based on the OBSERVER ratings (SELF excluded). Focused results reflect the average of observer scores only. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </p>

        <div className="three60-focus-table-wrapper">
          <table className="three60-focus-table">
            <thead className="three60-focus-table-header">
              <tr>
                <th className="three60-focus-th three60-focus-heart-column">Heart</th>
                <th style={{ ...styles.th, ...styles.heartColumn }}>Score</th>
                {[1, 2, 3, 4].map((num) => (
                  <th key={num} className="three60-focus-th">{num}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {questions.map((item, index) => {
                const avgScore = allResults[index]?.averageScore;
                return (
                  <tr key={index} className={index % 2 === 0 ? "three60-focus-row-even" : "three60-focus-row-odd"}>
                    <td className="three60-focus-td three60-focus-heart-column" title={item.question.replace(/\[First Name\]/g, respondentName)} >
                      {item.question.replace(/\[First Name\]/g, respondentName)}
                    </td>
                    <td style={{ ...styles.td }}>
                      {parseFloat(avgScore) > 0 ? avgScore : "-"}
                    </td>
                    {[0, 1, 2, 3].map((idx) => (
                      <td key={idx} style={styles.td}>
                        <div style={styles.rectangleWrapper}>
                          {renderRectangle(avgScore, idx)}
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default HeartPreview360;
